import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { AllAreaTranslator } from "@/js/translators/allAreaTranslator";
const allAreaRepository = RepositoryFactory.get("allArea");

const state = () => ({
  // all_area APIから取得した市町村情報の一部をリスト形式で格納する
  municipalities: {},
  // all_area APIから取得した都道府県情報の一部をリスト形式で格納する
  prefectures: {}
});

const getters = {};

const mutations = {
  setMunicipalities(state, payload) {
    state.municipalities = payload;
  },
  setPrefectures(state, payload) {
    state.prefectures = payload;
  }
};

const actions = {
  // all_area APIを叩き、レスポンスをそれぞれの形式で格納する
  async loadAllArea(context) {
    // APIを叩く
    const allAreaRes = await allAreaRepository.getAllAreaWithNational();
    // 200番台（成功時）、レスポンスを変換して格納
    if (allAreaRes.status < 300) {
      context.commit(
        "setMunicipalities",
        AllAreaTranslator.toMunicipalities(allAreaRes.data)
      );
      context.commit(
        "setPrefectures",
        AllAreaTranslator.toPrefectures(allAreaRes.data)
      );
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
